import { render, staticRenderFns } from "./SelectableRatingStarsBar.vue?vue&type=template&id=8b4e1d52&scoped=true&"
import script from "./SelectableRatingStarsBar.vue?vue&type=script&lang=ts&"
export * from "./SelectableRatingStarsBar.vue?vue&type=script&lang=ts&"
import style0 from "./SelectableRatingStarsBar.vue?vue&type=style&index=0&id=8b4e1d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4e1d52",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsStarIcon16px: require('/var/www/packages/theme/components/icons/star/StarIcon16px.vue').default})
